import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import ReactLoading from 'react-loading'
import { deleteInvoice, closeDeleteInvoiceModal } from 'redux/actions/invoices'


const DeleteModal = ({ isOpen, closeModal, invoice, deleteInvoice, isLoading, source, history }) => !invoice ? null : (
  <Modal isOpen={isOpen} fade={false} toggle={closeModal} className="warning">
    <ModalHeader toggle={closeModal}>Eliminar Factura</ModalHeader>
    <ModalBody>
      Estás seguro de que quieres borrar esta factura ?
    </ModalBody>
    <ModalFooter>
      <Button disabled={isLoading} color="warning" className="mr-1" onClick={() => deleteInvoice({ invoice, source, history })}>
        {isLoading && <ReactLoading type="spinningBubbles" color="#fff" height={10} width={10} className="d-inline-block mr-4 ml-2" />}
        Eliminar
      </Button>
      <Button disabled={isLoading} color="primary" onClick={closeModal}>Cancelar</Button>
    </ModalFooter>
  </Modal>
)

DeleteModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  invoice: PropTypes.shape({
    id: PropTypes.number.isRequired
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  source: PropTypes.string,
  closeModal: PropTypes.func.isRequired,
  deleteInvoice: PropTypes.func.isRequired,
}

const mapStateToProps = props => {
  
  const {invoices: { openedDeleteInvoiceModal, selectedInvoice, deletingInvoice, source }} = props
  return {
    isOpen: openedDeleteInvoiceModal,
    invoice: selectedInvoice,
    isLoading: deletingInvoice,
    source
  }
}

const mapDispatchToProps = dispatch => ({
  deleteInvoice: info => dispatch(deleteInvoice(info)),
  closeModal: () => dispatch(closeDeleteInvoiceModal()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DeleteModal))
